import { useState } from "react";
import { Routes, Route } from "react-router-dom";
import "./App.css";
import NavBar from "./components/NavBar.js";
import QuizScreen from "./components/QuizScreen.js";
import JoinScreen from "./components/JoinScreen.js";
import Footer from "./components/Footer.js";
import CourseScreen from "./components/CourseScreen.js";
import PaymentSuccess from "./components/Payment.js";

function App() {
  const [currentScreen, setCurrentScreen] = useState("join");

  return (
    <>
      <Routes>
        <Route
          path="/"
          element={
            <>
              {["join"].includes(currentScreen) && <NavBar />}
              {currentScreen === "join" && (
                <JoinScreen
                  start={() => setCurrentScreen("quiz")}
                  goToCourse={() => setCurrentScreen("course")}
                />
              )}
              {currentScreen === "quiz" && <QuizScreen />}
              {currentScreen === "course" && <CourseScreen />}
              {["join"].includes(currentScreen) && <Footer />}
            </>
          }
        />
        <Route path="/paymentsuccess" element={<PaymentSuccess />} />
      </Routes>
    </>
  );
}

export default App;
